var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
//React & Redux imports
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setReducerState } from "../../../redux/crudSlice";
//Helper
import dayjs from "dayjs";
import { FieldFailureReportsKeys } from "../services/entity";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { showSurface } from "../../../redux/awaitedSurfacesSlice";
import { fieldFailureReportsCreateAPI, fieldFailureReportsManualSearchAPI, getBranchListAPI, getPartListAPI, getRepairTypeList } from "../services/apiCalls";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { ServiceEstimateKeys } from "../../serviceEstimateM3/services/entity";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
import { showNotification } from "../../../redux/commonSlice";
//Component
import { CheckListDataGrid } from "../CheckList/ChecklistDataGrid";
//PopUp
import ConfirmationPopUp from "../components/confirmationPopUp";
//Icons & Style
import { Close, Download, MoreVert, Search } from "@mui/icons-material";
import { PrintIconSVG } from "../../spareParts/purchaseRequistion/assets/customIcons";
import { ShareIcon } from "../../../assets/images";
import { ReactComponent as LeftArrow } from '../../../assets/images/arrow-left.svg';
import { TrashIcon, InfoIcon } from "../../../assets/customIcons";
import { ReactComponent as LinkSvg } from '../../../assets/images/linkIcon.svg';
import useMediaQuery from "@mui/material/useMediaQuery";
import { PhysicalFormData, PhysicalFormDataMobileView } from "../components/fieldFailureReportCreateForm/PhysicalPhenamena";
import { getProductDetailsCard } from "../components/fieldFailureReportCreateForm/ProductDetailsCard";
import { CustomerComplaintCard } from "../components/fieldFailureReportCreateForm/CustomerComplaintCard";
import ActionMenuList from "../../../builderPackage/components/actionsMenuList";
import { AdditionalTab } from "../components/fieldFailureReportCreateForm/AdditionalTab";
import { basicDetailsAndVehicleDetails } from "../components/fieldFailureReportCreateForm/BasicDetailsAndVehicleDetails";
export var AddManualFieldFailureReport = function (props) {
    var _getLocalStorageItem$, _getLocalStorageItem, _userLoginData$data;
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var value = props.value, name = props.name;
    var ProductDetailsCard = getProductDetailsCard(lgMode);
    /**
     * Fetch data from redux
    */
    var crud = useAppSelector(function (state) { return state.crud; });
    //  * Update redux store
    //  */
    var dispatch = useAppDispatch();
    /**
     * ID to check is User Manual or Auto
     */
    var id = useParams().id;
    /**
     * For Navigation
     */
    var navigate = useNavigate();
    /**
     * Fetching data from local storage
     */
    var getSelectedChannelID = getLocalStorageItem('SELECTED_CHANNEL');
    /**
     * Fetching data from local storage
     */
    var localBranchList = getLocalStorageItem("SELECTED_BRANCH");
    var userLoginData = getLocalStorageItem("USER_LOGIN_DATA");
    /**
     * Taking current timestamp
     */
    var timestamp = dayjs().toISOString();
    var BasicDetailsAndVehicleDetails = basicDetailsAndVehicleDetails(true);
    /**
     * set reducer initial set
     */
    var handBackClick = function () {
        navigate('/fieldFailureReports');
        dispatch(setReducerState({
            key: FieldFailureReportsKeys.get,
            value: null
        }));
    };
    //General TAB
    var generalTab = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            sx: {
                border: '1px',
                borderRadius: "12px",
                borderColor: "secondary.200"
            },
            elements: __spreadArray(__spreadArray(__spreadArray(__spreadArray([], BasicDetailsAndVehicleDetails, true), ProductDetailsCard, true), [
                // --------------------------------------------------------------------------
                // Repair Details View Only Manual 
                // -------------------------------------------------------------------------- 
                {
                    type: FormItemTypes.CardComponent,
                    name: "RepairDetails",
                    label: "Repair Details",
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.SearchSelect,
                            name: 'BranchId',
                            label: 'Branch',
                            placeholder: 'Select dealer',
                            apiKey: 'branchList',
                            getListData: getBranchListAPI,
                            apiRequest: {
                                ParentOrganizationId: (_getLocalStorageItem$ = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH)) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.ParentOrganizationId) !== null && _getLocalStorageItem$ !== void 0 ? _getLocalStorageItem$ : '',
                                OrganizationTypeGroup: 2,
                                IsActive: 1
                            },
                            valueExpr: 'id',
                            displayExpr: 'Name',
                            required: true,
                            getOptionLabel: function (option) { return option ? "".concat(option.Name, " - ").concat(option.Code) : ""; }
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'JobCardNumber',
                            label: 'Job card number',
                            value: null,
                            placeholder: 'E.g JC-9939002',
                            validator: function (value, state) {
                                var jobCardRegex = /^[A-Za-z0-9-]+$/;
                                if (!jobCardRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                                    return 'Only alphanumeric characters and hyphens (-) are allowed';
                                }
                                if ((value === null || value === void 0 ? void 0 : value.length) < 10) {
                                    return 'Job card number must be at least 10 characters';
                                }
                                if ((value === null || value === void 0 ? void 0 : value.length) > 20) {
                                    return 'Job card number must be no longer than 20 characters';
                                }
                                return undefined;
                            }
                        }, {
                            type: FormItemTypes.SearchSelect,
                            name: 'PartCodeId',
                            label: 'Part',
                            required: true,
                            apiKey: ServiceEstimateKeys.PartList,
                            getListData: getPartListAPI,
                            valueExpr: 'id',
                            displayExpr: 'Name',
                            value: null,
                            getOptionLabel: function (option) { return option ? "".concat(option.Name, " - ").concat(option.SkuCode) : ""; }
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'VendorName',
                            label: 'Vendor name',
                            value: null,
                            placeholder: 'E.g Naveen Enterprises',
                            validator: function (value) {
                                var conditionRegex = /^[A-Za-z0-99\s]+$/; // Only letters and spaces
                                var leadingSpacesRegex = /^\S.*$/;
                                if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                                    return "Leading spaces are not allowed.";
                                }
                                if (!conditionRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                                    return "Special characters are not allowed";
                                }
                                return undefined;
                            }
                        }, {
                            type: FormItemTypes.SearchSelect,
                            label: 'Repair Type',
                            name: 'RepairTypeId',
                            value: null,
                            required: true,
                            apiKey: 'repairTypeList',
                            apiRequest: {
                                OrganizationId: localBranchList === null || localBranchList === void 0 ? void 0 : localBranchList.OrganizationId
                            },
                            getListData: getRepairTypeList,
                            displayExpr: 'Name',
                            valueExpr: 'id',
                            getOptionLabel: function (option) { return option ? "".concat(option.Name, " - ").concat(option.Code) : ""; }
                        }, {
                            type: FormItemTypes.DatePicker,
                            name: 'RepairDate',
                            label: 'Repair date',
                            value: null,
                            placeholder: 'E.g. 6 Jan, 2025',
                            setFieldProps: function (formValues) {
                                return {
                                    minDate: dayjs.utc(formValues.DateOfFailure)
                                };
                            }
                        }, {
                            type: FormItemTypes.DatePicker,
                            name: 'DateOfFailure',
                            label: 'Date of failure',
                            value: null,
                            disableFuture: true,
                            placeholder: 'E.g. 6 Jan, 2025',
                            required: true
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'KMReading',
                            label: 'KM reading',
                            placeholder: 'E.g. 1200',
                            validator: function (value) {
                                var conditionRegex = /^[0-99\s]+$/;
                                if (!conditionRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                                    return "Only numbers are allowed";
                                }
                                if ((value === null || value === void 0 ? void 0 : value.length) > 10) {
                                    return 'KM reading must be no longer than 10 digits';
                                }
                                return undefined;
                            }
                        }, {
                            type: FormItemTypes.DatePicker,
                            name: 'ReportDate',
                            label: 'Report date',
                            value: null,
                            placeholder: 'E.g. 6 Jan, 2025',
                            disableFuture: true
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'Reporter',
                            label: 'Reported ',
                            placeholder: 'E.g. Ganesh Tavde',
                            required: true,
                            validator: function (value, state) {
                                var nameRegex = /^[A-Za-z\s]+$/;
                                var leadingSpacesRegex = /^\S.*$/;
                                // Optional: block completely empty or all-space input
                                if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                                    return "Leading spaces are not allowed.";
                                }
                                if (!nameRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                                    return 'Only alphabetic characters are allowed';
                                }
                                if ((value === null || value === void 0 ? void 0 : value.length) < 5) {
                                    return 'Reported by must be at least 5 characters';
                                }
                                if ((value === null || value === void 0 ? void 0 : value.length) > 20) {
                                    return 'Reported by must be no longer than 20 characters';
                                }
                                return undefined;
                            }
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'ReporterContact',
                            label: 'Reporter mobile number',
                            placeholder: 'E.g. 9947829947',
                            required: true,
                            validator: function (value) {
                                var conditionRegex = /^[0-99\s]+$/;
                                var trimmedValue = value === null || value === void 0 ? void 0 : value.trim();
                                if (!conditionRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                                    return "Only numbers are allowed";
                                }
                                if (!trimmedValue || (trimmedValue === null || trimmedValue === void 0 ? void 0 : trimmedValue.length) !== 10) {
                                    return "Mobile number must be 10 digits";
                                }
                                if (/^(\d)\1{9}$/.test(trimmedValue)) {
                                    return "Invalid mobile number";
                                }
                                return undefined;
                            }
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'PartsReplaced',
                            value: null,
                            label: 'Parts replaced',
                            placeholder: 'E.g. Break Pads, etc.',
                            required: true,
                            validator: function (value) {
                                var leadingSpacesRegex = /^\S.*$/;
                                if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                                    return "Leading spaces are not allowed.";
                                }
                                return undefined;
                            }
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'VehicleStatusAfterRepair',
                            value: null,
                            label: 'Vehicle status after repair',
                            placeholder: 'E.g. Repaired',
                            required: true,
                            validator: function (value) {
                                var leadingSpacesRegex = /^\S.*$/;
                                if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                                    return "Leading spaces are not allowed.";
                                }
                                return undefined;
                            }
                        }]
                }], false), CustomerComplaintCard, true)
        }];
    //Page Header
    var formState = [
        //---------------------------------------------------------------------
        // Main Header
        //---------------------------------------------------------------------
        {
            type: FormItemTypes.ContainerItem,
            name: "PageHeader",
            columnSize: 12,
            justifyContent: 'space-between',
            spacing: 0,
            p: 1,
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    xs: 12,
                    sm: 5,
                    md: true,
                    lg: true,
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(LeftArrow, null),
                            sx: {
                                color: 'secondary.600'
                            },
                            columnSize: 0,
                            onClick: function () {
                                handBackClick();
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: "",
                            label: "",
                            children: "New field failure report",
                            columnSize: 0,
                            fontSize: "xxl",
                            fontWeight: "strong"
                        }, {
                            type: FormItemTypes.Chip,
                            name: "Open",
                            label: "Open",
                            value: null,
                            columnSize: true,
                            color: "primary",
                            sx: {
                                marginTop: '3px',
                                marginLeft: '5px'
                            }
                        }, !lgMode ? {
                            type: FormItemTypes.Button,
                            name: 'More',
                            children: /*#__PURE__*/ React.createElement(MoreVert, null),
                            size: 'small',
                            variant: 'text',
                            color: 'secondary',
                            sx: {
                                p: '7px'
                            },
                            columnSize: 0,
                            setFormState: function (state, e) { return __awaiter(void 0, void 0, void 0, function () {
                                var action;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Menu',
                                                containerProps: {
                                                    anchorEl: e.target.parentElement
                                                },
                                                Component: ActionMenuList,
                                                componentProps: {
                                                    items: [{
                                                            id: 'download',
                                                            children: "Download"
                                                        }, {
                                                            id: 'share',
                                                            children: "Share"
                                                        }, {
                                                            id: 'print',
                                                            children: "Print"
                                                        }, {
                                                            id: 'quick links',
                                                            children: 'Quick links'
                                                        }]
                                                }
                                            }))];
                                        case 1:
                                            action = _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }
                        } : null]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    xs: 12,
                    sm: true,
                    md: true,
                    lg: true,
                    spacing: 0,
                    item: false,
                    gap: 1,
                    justifyContent: {
                        xs: "space-between",
                        sm: 'end'
                    },
                    alignContent: 'center',
                    elements: lgMode ? [{
                            type: FormItemTypes.Typography,
                            name: "DocumentName",
                            label: "DOC NO :",
                            value: '-',
                            containerProps: {
                                justifyContent: {
                                    xs: "space-between",
                                    sm: 'end'
                                },
                                display: "inline-flex",
                                alignItems: "baseline",
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true
                            },
                            xs: 12,
                            sm: true,
                            md: true,
                            lg: true
                        }, {
                            type: FormItemTypes.Typography,
                            name: "DocumentDate",
                            label: "DOC DATE:",
                            containerProps: {
                                display: "inline-flex",
                                justifyContent: {
                                    xs: "space-between",
                                    sm: 'end'
                                },
                                alignItems: "baseline",
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true
                            },
                            columnSize: 0,
                            valueGetter: function (formValues, field) {
                                var _field$name;
                                var value = formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name !== void 0 ? _field$name : ""];
                                if (value) {
                                    return dayjs(value).format("DD MMM, YYYY");
                                }
                                return dayjs().format("DD MMM, YYYY");
                            }
                        }] : [{
                            type: FormItemTypes.Typography,
                            name: "DocumentName",
                            label: "DOC NO :",
                            value: '-',
                            containerProps: {
                                justifyContent: {
                                    xs: "space-between",
                                    sm: 'end'
                                },
                                display: "inline-flex",
                                alignItems: "baseline",
                                gap: 1,
                                mx: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                mx: 1,
                                noWrap: true
                            },
                            xs: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: "DocumentDate",
                            label: "DOC DATE:",
                            value: '-',
                            containerProps: {
                                display: "inline-flex",
                                mx: 1,
                                justifyContent: {
                                    xs: "space-between",
                                    sm: 'end'
                                },
                                alignItems: "baseline",
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                mx: 1,
                                noWrap: true
                            },
                            xs: 12,
                            valueGetter: function (formValues, field) {
                                var _field$name2, _field$name3;
                                return formValues !== null && formValues !== void 0 && formValues[(_field$name2 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name2 !== void 0 ? _field$name2 : ""] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name3 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name3 !== void 0 ? _field$name3 : ""]).format("DD MMM, YYYY") : "-";
                            }
                        }]
                }]
        },
        // ---------------------------------------------------------------------
        // Manual View Header - Search Quick link & rest button
        // ---------------------------------------------------------------------
        {
            type: FormItemTypes.ContainerItem,
            name: 'Search Quick link & rest button',
            columnSize: 12,
            m: 1,
            alignItems: 'center',
            pb: 2,
            borderTop: '1px solid ',
            borderBottom: '1px solid ',
            borderColor: 'secondary.200',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: true,
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.CardComponent,
                            name: '',
                            columnSize: true,
                            contentProps: {
                                alignItems: 'center',
                                spacing: 0.5
                            },
                            sx: {
                                px: '7px',
                                py: '3px'
                            },
                            elements: [{
                                    type: FormItemTypes.IconButton,
                                    name: "searchIcon",
                                    columnSize: 0,
                                    color: 'secondary',
                                    children: /*#__PURE__*/ React.createElement(Search, {
                                        color: "secondary"
                                    }),
                                    setFormState: function (formValues) { return __awaiter(void 0, void 0, void 0, function () {
                                        var search, res;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    search = formValues === null || formValues === void 0 ? void 0 : formValues.search;
                                                    formValues.isDataFetched = false;
                                                    if (!search) return [3 /*break*/, 2];
                                                    return [4 /*yield*/, fieldFailureReportsManualSearchAPI({
                                                            request: {
                                                                Key: "VinNo",
                                                                Value: search
                                                            }
                                                        })];
                                                case 1:
                                                    res = _a.sent();
                                                    if (res.data) {
                                                        return [2 /*return*/, _objectSpread(_objectSpread({}, res.data), {}, {
                                                                isDataFetched: !(formValues !== null && formValues !== void 0 && formValues.isDataFetched)
                                                            })];
                                                    }
                                                    else if (!res.success) {
                                                        dispatch(showNotification({
                                                            isOpen: true,
                                                            message: res.message,
                                                            type: "error"
                                                        }));
                                                    }
                                                    _a.label = 2;
                                                case 2: return [2 /*return*/];
                                            }
                                        });
                                    }); }
                                }, {
                                    type: FormItemTypes.TextInput,
                                    name: "search",
                                    placeholder: "Search & select chassis number",
                                    columnSize: true,
                                    variant: 'standard',
                                    InputProps: {
                                        disableUnderline: true
                                    },
                                    validator: function (value) {
                                        var trimmedValue = value === null || value === void 0 ? void 0 : value.trim();
                                        if (!trimmedValue || (trimmedValue === null || trimmedValue === void 0 ? void 0 : trimmedValue.length) !== 17) {
                                            return "Chassis number must be 17 digits";
                                        }
                                        return undefined;
                                    }
                                }, {
                                    type: FormItemTypes.IconButton,
                                    name: "clear",
                                    columnSize: 0,
                                    children: /*#__PURE__*/ React.createElement(Close, {
                                        color: "secondary"
                                    }),
                                    color: 'secondary',
                                    setFieldProps: function (formValues) {
                                        return {
                                            type: this.type,
                                            sx: {
                                                display: formValues !== null && formValues !== void 0 && formValues.search ? 'flex' : 'none'
                                            }
                                        };
                                    },
                                    setFormState: function (formValues) { return ({
                                        search: ''
                                    }); }
                                }]
                        }]
                }, lgMode ? {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 8,
                    spacing: 0,
                    justifyContent: 'end',
                    display: 'flex',
                    setFieldProps: function (formValues) {
                        var _this = this;
                        return {
                            type: this.type,
                            elements: formValues !== null && formValues !== void 0 && formValues.isDataFetched ? [{
                                    type: FormItemTypes.Button,
                                    name: '',
                                    variant: 'text',
                                    children: 'Quick links',
                                    columnSize: 0,
                                    sx: {
                                        bgcolor: 'transparent',
                                        fontWeight: 'medium'
                                    },
                                    startIcon: /*#__PURE__*/ React.createElement(LinkSvg, null)
                                }, {
                                    type: FormItemTypes.Button,
                                    name: '',
                                    children: /*#__PURE__*/ React.createElement(Download, null),
                                    columnSize: 0,
                                    variant: 'outlined',
                                    disabled: true,
                                    sx: {
                                        mr: 1
                                    },
                                    size: 'icon'
                                }, {
                                    type: FormItemTypes.Button,
                                    name: '',
                                    children: /*#__PURE__*/ React.createElement("img", {
                                        src: ShareIcon,
                                        alt: "",
                                        loading: "lazy"
                                    }),
                                    columnSize: 0,
                                    variant: 'outlined',
                                    disabled: true,
                                    size: 'icon'
                                }, {
                                    type: FormItemTypes.Button,
                                    name: '',
                                    children: /*#__PURE__*/ React.createElement(PrintIconSVG, null),
                                    columnSize: 0,
                                    variant: 'outlined',
                                    sx: {
                                        mx: 1
                                    },
                                    disabled: true,
                                    size: 'icon'
                                }, {
                                    type: FormItemTypes.Divider,
                                    name: '',
                                    columnSize: 0,
                                    orientation: 'vertical',
                                    variant: 'fullWidth'
                                }, {
                                    type: FormItemTypes.Button,
                                    name: "Discard",
                                    label: "",
                                    value: "discard",
                                    children: "Discard",
                                    columnSize: 0,
                                    variant: "text",
                                    color: "secondary",
                                    setFormState: function (formValues) { return __awaiter(_this, void 0, void 0, function () {
                                        var result;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                                        type: 'Dialog',
                                                        Component: ConfirmationPopUp,
                                                        containerProps: {
                                                            maxWidth: 'xs'
                                                        },
                                                        //Passing dynamic props
                                                        componentProps: {
                                                            unsavedChangesMessage: 'You have unsaved changes. Are you sure you want to proceed?',
                                                            changesLostMessage: 'Your changes will be lost if you proceed.',
                                                            confirmButtonLabel: 'Discard',
                                                            discardButtonLabel: 'Cancel',
                                                            icon: /*#__PURE__*/ React.createElement(TrashIcon, null),
                                                            bgColor: 'error.100',
                                                            hoverbgColor: 'error.100'
                                                            // onClose: (isConfirmed: boolean) => {
                                                            // },
                                                        }
                                                    }))];
                                                case 1:
                                                    result = _a.sent();
                                                    //Clearing form state for discard functionality
                                                    if (result.payload)
                                                        dispatch(setReducerState({
                                                            key: FieldFailureReportsKeys.ManualSearchGetData,
                                                            value: null
                                                        }));
                                                    dispatch(setReducerState({
                                                        key: FieldFailureReportsKeys.get,
                                                        value: null
                                                    }));
                                                    return [2 /*return*/, {
                                                            isDataFetched: !(formValues !== null && formValues !== void 0 && formValues.isDataFetched)
                                                        }];
                                            }
                                        });
                                    }); }
                                },
                                //Update FFR API call
                                {
                                    type: FormItemTypes.Button,
                                    name: "form-save",
                                    children: "Save",
                                    columnSize: 0,
                                    variant: "outlined",
                                    color: "secondary",
                                    sx: {
                                        mr: 1
                                    },
                                    setFormState: function () {
                                        return {
                                            IsSubmit: 0
                                        };
                                    },
                                    onClick: function (e, formvalues) {
                                        return "submit";
                                    }
                                },
                                //Create FFR API call
                                {
                                    type: FormItemTypes.Button,
                                    name: "form-submit",
                                    children: "Submit",
                                    columnSize: 0,
                                    variant: "contained",
                                    color: "primary",
                                    setFormState: function () { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            return [2 /*return*/, {
                                                    IsSubmit: 1
                                                }];
                                        });
                                    }); },
                                    sx: {
                                        mr: 1
                                    },
                                    onClick: function () {
                                        return __awaiter(this, void 0, void 0, function () {
                                            var result;
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0: return [4 /*yield*/, dispatch(showSurface({
                                                            type: 'Dialog',
                                                            Component: ConfirmationPopUp,
                                                            containerProps: {
                                                                fullWidth: true,
                                                                PaperProps: {
                                                                    sx: {
                                                                        borderRadius: '12px',
                                                                        width: {
                                                                            sm: '350px',
                                                                            md: '450px',
                                                                            lg: '450px'
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            //Passing dynamic props
                                                            componentProps: {
                                                                unsavedChangesMessage: 'Are sure you want to submit?',
                                                                changesLostMessage: 'Document cannot be edited after submission.',
                                                                confirmButtonLabel: 'Submit',
                                                                discardButtonLabel: 'Cancel',
                                                                icon: /*#__PURE__*/ React.createElement(InfoIcon, null),
                                                                bgColor: 'warning.100',
                                                                hoverbgColor: 'warning.100'
                                                                // onClose: (isConfirmed: boolean) => {
                                                                //   console.log(isConfirmed ? 'Confirmed' : 'Canceled');
                                                                // },
                                                            }
                                                        }))];
                                                    case 1:
                                                        result = _a.sent();
                                                        if (result.payload) {
                                                            return [2 /*return*/, 'submit'];
                                                        }
                                                        return [2 /*return*/];
                                                }
                                            });
                                        });
                                    }
                                }] : []
                        };
                    }
                } : null]
        },
        // -------------------------------------------------------------------------
        //Tabs
        // ----------------------------------------------------------------------------
        {
            type: FormItemTypes.ContainerItem,
            name: "tab",
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.Tabs,
                    name: "tab",
                    panelGridProps: {
                        px: 3
                    },
                    tabs: [{
                            id: "0",
                            label: "General",
                            elements: generalTab
                        }, {
                            id: "1",
                            label: "Physical Phenomena",
                            elements: lgMode ? PhysicalFormData : PhysicalFormDataMobileView
                        }, {
                            id: "2",
                            label: "Additional info",
                            elements: AdditionalTab
                        }, {
                            id: "3",
                            label: "Checklist",
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: "",
                                    columnSize: 12,
                                    spacing: 0,
                                    columnGap: 1.5,
                                    alignItems: "center",
                                    py: 2.5,
                                    px: 2,
                                    elements: [{
                                            type: FormItemTypes.Custom,
                                            name: "ChecklistFeedbackData",
                                            columnSize: 12,
                                            element: CheckListDataGrid
                                        }]
                                }]
                        }],
                    valueExpr: "id",
                    displayExpr: "label",
                    columnSize: 12,
                    variant: "scrollable",
                    sx: {
                        margin: "0px 24px"
                    }
                }],
            setFieldProps: function (formValues, currValue, field) {
                return {
                    type: this.type,
                    display: formValues !== null && formValues !== void 0 && formValues.isDataFetched ? 'flex' : 'none'
                };
            }
        }, !lgMode && crud[FieldFailureReportsKeys.ManualSearchGetData] ? {
            type: FormItemTypes.ContainerItem,
            name: 'Footer',
            columnSize: 12,
            justifyContent: 'end',
            sx: {
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                padding: 2,
                backgroundColor: 'background.paper',
                borderTop: '1px solid',
                borderColor: 'divider',
                zIndex: 1
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: null,
                    columnSize: 12,
                    item: false,
                    spacing: 1,
                    alignItems: "center",
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "Discard",
                            label: "",
                            value: "discard",
                            children: "Discard",
                            columnSize: true,
                            variant: "text",
                            color: "secondary",
                            setFormState: function (formValues) { return __awaiter(void 0, void 0, void 0, function () {
                                var result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Dialog',
                                                Component: ConfirmationPopUp,
                                                containerProps: {
                                                    maxWidth: 'xs'
                                                },
                                                //Passing dynamic props
                                                componentProps: {
                                                    unsavedChangesMessage: 'You have unsaved changes. Are you sure you want to proceed?',
                                                    changesLostMessage: 'Your changes will be lost if you proceed.',
                                                    confirmButtonLabel: 'Discard',
                                                    discardButtonLabel: 'Cancel',
                                                    icon: /*#__PURE__*/ React.createElement(TrashIcon, null),
                                                    bgColor: 'error.100',
                                                    hoverbgColor: 'error.100'
                                                    // onClose: (isConfirmed: boolean) => {
                                                    //   console.log(isConfirmed ? 'Confirmed' : 'Canceled');
                                                    // },
                                                }
                                            }))];
                                        case 1:
                                            result = _a.sent();
                                            //Clearing form state for discard functionality
                                            if (result.payload)
                                                dispatch(setReducerState({
                                                    key: FieldFailureReportsKeys.ManualSearchGetData,
                                                    value: null
                                                }));
                                            dispatch(setReducerState({
                                                key: FieldFailureReportsKeys.get,
                                                value: null
                                            }));
                                            return [2 /*return*/, {
                                                    isDataFetched: !(formValues !== null && formValues !== void 0 && formValues.isDataFetched)
                                                }];
                                    }
                                });
                            }); }
                        },
                        //Update FFR API call
                        {
                            type: FormItemTypes.Button,
                            name: "form-save",
                            children: "Save",
                            columnSize: 0,
                            variant: "outlined",
                            color: "secondary",
                            sx: {
                                mr: 1
                            },
                            setFormState: function () {
                                return {
                                    IsSubmit: 0
                                };
                            },
                            onClick: function (e, formvalues) {
                                return "submit";
                            }
                        },
                        //Create FFR API call
                        {
                            type: FormItemTypes.Button,
                            name: "form-submit",
                            children: "Submit",
                            columnSize: 0,
                            variant: "contained",
                            color: "primary",
                            setFormState: function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    return [2 /*return*/, {
                                            IsSubmit: 1
                                        }];
                                });
                            }); },
                            sx: {
                                mr: 1
                            },
                            onClick: function () {
                                return __awaiter(this, void 0, void 0, function () {
                                    var result;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, dispatch(showSurface({
                                                    type: 'Dialog',
                                                    Component: ConfirmationPopUp,
                                                    containerProps: {
                                                        fullWidth: true,
                                                        PaperProps: {
                                                            sx: {
                                                                borderRadius: '12px',
                                                                width: {
                                                                    sm: '350px',
                                                                    md: '450px',
                                                                    lg: '450px'
                                                                }
                                                            }
                                                        }
                                                    },
                                                    //Passing dynamic props
                                                    componentProps: {
                                                        unsavedChangesMessage: 'Are sure you want to submit?',
                                                        changesLostMessage: 'Document cannot be edited after submission.',
                                                        confirmButtonLabel: 'Submit',
                                                        discardButtonLabel: 'Cancel',
                                                        icon: /*#__PURE__*/ React.createElement(InfoIcon, null),
                                                        bgColor: 'warning.100',
                                                        hoverbgColor: 'warning.100'
                                                        // onClose: (isConfirmed: boolean) => {
                                                        //   console.log(isConfirmed ? 'Confirmed' : 'Canceled');
                                                        // },
                                                    }
                                                }))];
                                            case 1:
                                                result = _a.sent();
                                                if (result.payload) {
                                                    return [2 /*return*/, 'submit'];
                                                }
                                                return [2 /*return*/];
                                        }
                                    });
                                });
                            }
                        }]
                }]
        } : null
    ];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        gridProps: {
            spacing: 0
        },
        createFormAPI: fieldFailureReportsCreateAPI,
        createKey: FieldFailureReportsKeys.create,
        createRequest: {
            IsManual: 1,
            ChannelId: getSelectedChannelID === null || getSelectedChannelID === void 0 ? void 0 : getSelectedChannelID.ChannelId,
            BranchId: localBranchList === null || localBranchList === void 0 ? void 0 : localBranchList.OrganizationId,
            OrganizationId: localBranchList === null || localBranchList === void 0 ? void 0 : localBranchList.ParentOrganizationId,
            UserId: userLoginData === null || userLoginData === void 0 || (_userLoginData$data = userLoginData.data) === null || _userLoginData$data === void 0 ? void 0 : _userLoginData$data.IdentityId
        },
        formData: formState
    }));
};
